import React, { forwardRef, useImperativeHandle, useState, useRef } from 'react';
import styles from './CardHeaderProposta.module.scss';
import Shareds from '../../../../config/translations/Shareds';
import { Button } from 'primereact/button';
import { arrayToDateString } from '../../../../core/utils/DateMixins';
import { useHistory, useLocation } from 'react-router-dom';
import Pages from '../../../../config/Pages';
import propostaIndicadorService from '../../../../service/PropostaIndicadorService';
import { printToast } from '../../../../core/utils/Global';
import { errosTratados } from '../../../../config/Axios';
import PageMessages from '../../../../config/translations/PageMessages';
import ModalJustificativa from '../../propostaIndicador/components/modalJustificativa/ModalJustificativa';
import { download } from '../../../../core/utils/Exporter';

function CardHeaderProposta(
    { proposta: propostaSelected, multipagePropostaRef, onRemove, onCancelar },
    ref
) {
    const history = useHistory();
    const location = useLocation();
    const modalJustificativaRef = useRef(null);
    const item = (title, value) => ({ title, value });
    const [proposta, setProposta] = useState(propostaSelected ?? {});
    const items = [
        item('Cód proposta', proposta?.id),
        item('Versão', proposta?.numrVersao),
        item(
            'Última Alteração',
            Array.isArray(proposta?.dataAtualizacao)
                ? arrayToDateString(proposta?.dataAtualizacao, true)
                : null
        ),
        item('Usuário de Alteração', proposta?.contaAcessoAtualizacao?.nome),
        item('Situação da Proposta', proposta?.situacaoProposta?.descSituacao),
        item(
            'Analista Metodológico',
            proposta?.avaliacaoMetodologica?.responsavelAnalise?.nomePessoa
        ),
        item('Analista Negocial', proposta?.avaliacaoNegocial?.responsavelAnalise?.nomePessoa),
    ];

    useImperativeHandle(ref, () => ({ proposta, setProposta }), [proposta]);

    return (
        <>
            <ModalJustificativa
                ref={modalJustificativaRef}
                onSave={({ success }) => {
                    if (success) {
                        modalJustificativaRef.current?.hide();
                        if (onCancelar) {
                            onCancelar();
                        }
                    }
                }}
            />
            <div className={`${styles.stateBar}`}>
                {items.map((el, ind) => (
                    <div key={ind}>
                        <span>{el?.title}</span>
                        <div>{el?.value ?? Shareds.naoDefinido}</div>
                    </div>
                ))}
                <div>
                    <span>Ações</span>
                    <div className={styles.containerButtons}>
                        <Button
                            className="pi pi-arrow-right-arrow-left p-button-help"
                            tooltip="Status da Proposta"
                            tooltipOptions={{ position: 'top' }}
                            onClick={() => {
                                history.replace({
                                    ...location,
                                    pathname: Pages.sei.statusProposta.url.list.replace(
                                        ':id',
                                        proposta?.id
                                    ),
                                    state: { from: location.pathname },
                                });
                            }}
                        />
                        {proposta?.situacaoProposta?.codgSituacaoProposta === 'CADASTRO' && (
                            <Button
                                className="pi pi-trash p-button-raised p-button-text p-button-danger"
                                tooltip="Excluir"
                                tooltipOptions={{ position: 'top' }}
                                onClick={() => {
                                    if (multipagePropostaRef) {
                                        multipagePropostaRef.current.multipageData.confirmRef.current?.show(
                                            Shareds.form.confirmDelete,
                                            async () => {
                                                try {
                                                    await propostaIndicadorService.remover(
                                                        proposta
                                                    );
                                                    if (onRemove) {
                                                        onRemove();
                                                    }
                                                    printToast({
                                                        severity: 'success',
                                                        summary: Pages.sei.propostaIndicador.title,
                                                        detail: Shareds.form.successDelete,
                                                    });
                                                } catch (error) {
                                                    if (
                                                        !errosTratados.includes(
                                                            error?.response?.status
                                                        )
                                                    ) {
                                                        printToast({
                                                            severity: 'error',
                                                            summary:
                                                                Pages.sei.propostaIndicador.title,
                                                            detail: Shareds.form.errorDelete,
                                                        });
                                                    }
                                                }
                                            }
                                        );
                                    }
                                }}
                            />
                        )}
                        {proposta?.situacaoProposta?.codgSituacaoProposta !== 'APROVADA' && (
                            <Button
                                className="pi pi-ban p-button-danger"
                                tooltip="Cancelar"
                                tooltipOptions={{ position: 'top' }}
                                onClick={() => {
                                    if (multipagePropostaRef) {
                                        if (
                                            proposta?.situacaoProposta?.codgSituacaoProposta ===
                                            'CANCELADA'
                                        ) {
                                            modalJustificativaRef.current?.show(proposta);
                                        } else {
                                            multipagePropostaRef.current.multipageData.confirmRef.current?.show(
                                                PageMessages.sei.propostaIndicador.cancelar,
                                                () =>
                                                    setTimeout(
                                                        () =>
                                                            modalJustificativaRef.current?.show(
                                                                proposta
                                                            ),
                                                        300
                                                    )
                                            );
                                        }
                                    }
                                }}
                            />
                        )}
                        <Button
                            className="pi pi-print p-button-secondary p-button-raised p-button-text"
                            tooltip="Resumo de Alterações"
                            tooltipOptions={{ position: 'top' }}
                            onClick={async () => {
                                const response =
                                    await propostaIndicadorService.getRelatorioResumoProposta(
                                        proposta?.id
                                    );
                                download(response, 'Resumo', 'pdf');
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}

export default forwardRef(CardHeaderProposta);
